import { render } from "./agents.vue?vue&type=template&id=a88603aa&scoped=true"
import script from "./agents.vue?vue&type=script&lang=js"
export * from "./agents.vue?vue&type=script&lang=js"

import "./agents.vue?vue&type=style&index=0&id=a88603aa&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88603aa"]])

export default __exports__